export default "<a style=\"cursor: pointer;\" (click)=\"goBack()\"><p>zurück</p></a>";